<form novalidate *ngIf="!wizardCtrl.getWizardService().isLoading" #currentForm="ngForm">
  <div class="group parent-input-width" *ngIf="!showFusionLogLevel">
    <p class="label">Title *</p>
    <input
      matInput
      class="input-width"
      name="identifier"
      placeholder="Enter identifier"
      [(ngModel)]="identifier"
      #identifierInput="ngModel"
      [disabled]="wizardService.editMode"
      (ngModelChange)="identifierUpdated()"
      maxlength="50"
      required
    />
    <div
      class="error"
      *ngIf="identifierInput.invalid && (identifierInput.dirty || identifierInput.touched)"
    >
      <mat-error *ngIf="identifierInput.errors.maxlength">Identifier is too long</mat-error>
      <mat-error *ngIf="identifierInput.errors.required">Identifier is required</mat-error>
      <mat-error *ngIf="identifierInput.errors.matchPattern"
        >Syslog output name must consist of lower case alphanumeric characters, '-' or '.', and must
        start and end with an alphanumeric character</mat-error
      >
    </div>
  </div>

  <div *ngIf="!wizardCtrl.getWizardService().isLoading && !showFusionLogLevel">
    <div class="group parent-input-width enable-input">
      <label class="label en-margin">Enable</label>
      <mat-slide-toggle
        color="primary"
        name="enabled"
        [(ngModel)]="enabled"
        (change)="enabledUpdated()"
      ></mat-slide-toggle>
    </div>
    <div class="group parent-input-width">
      <p class="label">Host *</p>
      <input
        autocomplete="off"
        matInput
        class="hostname input-width"
        name="host"
        placeholder="Enter host"
        [(ngModel)]="host"
        #hostInput="ngModel"
        (ngModelChange)="hostUpdated()"
        maxlength="80"
        required
      />
      <div class="error" *ngIf="hostInput.invalid && (hostInput.dirty || hostInput.touched)">
        <mat-error *ngIf="hostInput.errors.maxlength">Host is too long</mat-error>
        <mat-error *ngIf="hostInput.errors.required">Host is required</mat-error>
        <mat-error *ngIf="hostInput.errors.matchPattern">Host is invalid</mat-error>
      </div>
    </div>
    <div class="group parent-input-width">
      <p class="label">Port *</p>

      <input
        autocomplete="off"
        matInput
        class="port input-width"
        name="port"
        placeholder="Enter port"
        type="number"
        min="1"
        max="65535"
        [(ngModel)]="port"
        #portInput="ngModel"
        (ngModelChange)="portUpdated()"
        required
      />
      <div class="error" *ngIf="portInput.invalid && (portInput.dirty || portInput.touched)">
        <mat-error *ngIf="portInput.errors.required">Port is required</mat-error>
        <mat-error *ngIf="portInput.errors.min">Port should be 1 to 65535</mat-error>
        <mat-error *ngIf="portInput.errors.max">Port should be 1 to 65535</mat-error>
      </div>
    </div>
    <div class="group parent-input-width">
      <p class="label">Protocol *</p>

      <select
        #protocolInput="ngModel"
        name="protocol"
        (change)="protocolUpdated()"
        [(ngModel)]="protocol"
      >
        <option *ngFor="let protocol of protocolList" [ngValue]="protocol.id">
          {{ protocol.value }}
        </option>
      </select>
      <div
        class="error"
        *ngIf="protocolInput.invalid && (protocolInput.dirty || protocolInput.touched)"
      >
        <mat-error *ngIf="protocolInput.errors.required">protocol is required</mat-error>
      </div>
    </div>
    <div class="group parent-input-width">
      <p class="label">Log level *</p>
      <select
        #severityInput="ngModel"
        name="severity"
        (change)="severityUpdated()"
        [(ngModel)]="severity"
      >
        <option *ngFor="let logLevel of logLevelList" [ngValue]="logLevel.id">
          {{ logLevel.value }}
        </option>
      </select>
      <div
        class="error"
        *ngIf="severityInput.invalid && (severityInput.dirty || severityInput.touched)"
      >
        <mat-error *ngIf="severityInput.errors.required">Log Level is required</mat-error>
      </div>
    </div>
  </div>

  <div *ngIf="showFusionLogLevel">
    <div class="group">
      <p class="label">Title *</p>
      <input
        matInput
        name="identifier"
        placeholder="Enter identifier"
        [(ngModel)]="identifier"
        #identifierInput="ngModel"
        [disabled]="wizardService.editMode"
        (ngModelChange)="identifierUpdated()"
        maxlength="50"
        required
        class="width-100"
      />
      <div
        class="error"
        *ngIf="identifierInput.invalid && (identifierInput.dirty || identifierInput.touched)"
      >
        <mat-error *ngIf="identifierInput.errors.maxlength">Identifier is too long</mat-error>
        <mat-error *ngIf="identifierInput.errors.required">Identifier is required</mat-error>
        <mat-error *ngIf="identifierInput.errors.matchPattern"
          >Syslog output name must consist of lower case alphanumeric characters, '-' or '.', and
          must start and end with an alphanumeric character</mat-error
        >
      </div>
    </div>
    <div class="server-config-form" *ngIf="!wizardCtrl.getWizardService().isLoading">
      <div class="group">
        <label class="label">Enable</label>
        <mat-slide-toggle
          color="primary"
          name="enabled"
          [(ngModel)]="enabled"
          (change)="enabledUpdated()"
        ></mat-slide-toggle>
      </div>
      <div class="group">
        <p class="label">Host *</p>
        <input
          autocomplete="off"
          matInput
          name="host"
          placeholder="Enter host"
          [(ngModel)]="host"
          #hostInput="ngModel"
          (ngModelChange)="hostUpdated()"
          maxlength="80"
          required
        />
        <div class="error" *ngIf="hostInput.invalid && (hostInput.dirty || hostInput.touched)">
          <mat-error *ngIf="hostInput.errors.maxlength">Host is too long</mat-error>
          <mat-error *ngIf="hostInput.errors.required">Host is required</mat-error>
          <mat-error *ngIf="hostInput.errors.matchPattern">Host is invalid</mat-error>
        </div>
      </div>
      <div class="group">
        <p class="label">Port *</p>

        <input
          autocomplete="off"
          matInput
          name="port"
          placeholder="Enter port"
          type="number"
          min="1"
          max="65535"
          [(ngModel)]="port"
          #portInput="ngModel"
          (ngModelChange)="portUpdated()"
          required
        />
        <div class="error" *ngIf="portInput.invalid && (portInput.dirty || portInput.touched)">
          <mat-error *ngIf="portInput.errors.required">Port is required</mat-error>
          <mat-error *ngIf="portInput.errors.min">Port should be 1 to 65535</mat-error>
          <mat-error *ngIf="portInput.errors.max">Port should be 1 to 65535</mat-error>
        </div>
      </div>
      <div class="group">
        <p class="label">Protocol *</p>
        <select
          #protocolInput="ngModel"
          name="protocol"
          (change)="protocolUpdated()"
          [(ngModel)]="protocol"
        >
          <option *ngFor="let protocol of protocolList" [ngValue]="protocol.id">
            {{ protocol.value }}
          </option>
        </select>
        <div
          class="error"
          *ngIf="protocolInput.invalid && (protocolInput.dirty || protocolInput.touched)"
        >
          <mat-error *ngIf="protocolInput.errors.required">protocol is required</mat-error>
        </div>
      </div>
      <div class="group" style="visibility: hidden; height: 0; padding: 0; margin: 0">
        <p class="label">Log Level *</p>
        <input autocomplete="off" matInput class="debug" name="debug" value="Debug" readonly />
      </div>
    </div>
  </div>
</form>

<div *ngIf="wizardCtrl.getWizardService().isLoading" class="loader">
  <div class="loader-msg-header">
    <p>{{loadMessage}}</p>
  </div>
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
